import {yupResolver} from '@hookform/resolvers/yup/dist/yup';
import React, {useEffect, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useNavigate, useParams} from 'react-router-dom';
import {Card, CardBody, Col, Form, Row} from 'reactstrap';
import * as yup from 'yup';
import {channelsApi} from '../../../../api';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../../components/block/Block';
import Button from '../../../../components/button/Button';
import Icon from '../../../../components/icon/Icon';
import {EPrices} from '../../../../shared/IPrices';
import {IFormat} from '../../formats/interfaces/IFormat';
import {IQuality} from '../../quality/interfaces/IQuality';
import {IChannel} from '../interfaces/IChannel';
import ChannelForm from './ChannelForm';

export const channelFormSchema = yup
  .object({
    name: yup.string().required('No name provided.').min(3, 'Name is too short - should be 3 chars minimum.'),

    quality: yup.number().required('No quality provided.'),
    thresholdInvestment: yup.number().typeError('No threshold provided.').required('No threshold provided.'),
    status: yup.boolean().required(),
    channelCheckPrice: yup
      .array()
      .min(1)
      .required()
      .typeError(`Prices should be one of ${Object.keys(EPrices)}`),
    percentageTargeting: yup
      .number()
      .nullable(true)
      .when('targeting', {
        is: true,
        then: yup.number().min(0).max(100).required(),
      }),
  })
  .required();
const ChannelUpdate = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [passState, setPassState] = useState(false);
  const {id} = useParams();
  const methods = useForm<IChannel>({
    resolver: yupResolver(channelFormSchema),
  });

  const onFormSubmit = async (state: IChannel) => {
    const formData = new FormData();
    const pictureToSend: FileList = state.picture as FileList;
    !!state.picture && formData.append('picture', pictureToSend[0]);
    formData.append('body', JSON.stringify(state));
    const {data} = await channelsApi.updateChannel(Number(id), formData);
    if (data) {
      navigate(-1);
    }
  };

  useEffect(() => {
    if (id) {
      const getChannel = async (channelId: number) => {
        const {data} = await channelsApi.getChannel(+channelId);

        methods?.reset({
          ...data,
          format: (data.format as unknown as IFormat)?.id,
          quality: (data.quality as unknown as IQuality)?.id,
        });
      };
      getChannel(+id);
    }
  }, [id, methods]);
  return (
    <Block size="lg" className="mt-3">
      <BlockHead>
        <BlockHeadContent>
          <div className="row align-items-center gx-0 gx-lg-2">
            <div className="col-md-10 col-12">
              <BlockTitle tag="h4">{t('administrator.channels.channelUpdate')}</BlockTitle>
            </div>
            <div className="col-md-2 col-12 text-end">
              <Button
                className="btn-block"
                color="secondary"
                onClick={() => {
                  navigate('/app/admin/channels');
                }}
              >
                <Icon name="arrow-long-left" />
                {t('general.back')}
              </Button>
            </div>
          </div>
        </BlockHeadContent>
      </BlockHead>
      <Card className="card-bordered card-preview">
        <CardBody>
          <FormProvider {...methods}>
            <Form onSubmit={methods?.handleSubmit(onFormSubmit)} className="py-3">
              <ChannelForm
                passState={passState}
                setPassState={setPassState}
                register={methods?.register}
                isTargeting={!!methods?.watch('targeting')}
                defaultState={methods?.formState?.defaultValues as IChannel}
                errors={methods?.formState?.errors}
              />
              <Row>
                <Col>
                  <Row>
                    <Col className={'text-end'}>
                      <Button color="primary">
                        <Icon name="plus-sm" />
                        {t('general.update')}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </FormProvider>
        </CardBody>
      </Card>
    </Block>
  );
};

export default ChannelUpdate;
